/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReleaseComponent } from './releaseComponent';


export interface Components { 
    /**
     * Map of Release components with Component Type as the Key
     */
    release_component: { [key: string]: ReleaseComponent; };
    /**
     * (Deprecated by skipValidation flag)
     */
    testing?: boolean;
}

